import { taskTypeDef } from "./task-type-def";

export const taskServiceTypeDef = `
  ${taskTypeDef}
  damageNumber
  serviceNumber
  leasingApprovalNumber
  carVin
  carLicensePlate
  carNonstandardLicensePlate
  carYearManufactured
  carModel
  completedAt
  centralEventNumber
`;
